module.exports = __webpack_public_path__ + "img/new_59.feb0c97a.jpg";